import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { signup } from '../store/authSlice.js';
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { db } from '../firebase.js';
import { ref, update } from "firebase/database";
import { auth } from '../firebase.js';

const AdminSignup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await dispatch(signup({ email, password, name, phone })).unwrap();
      // Set isAdmin: true for admin accounts
      if (result?.uid && db) {
        await update(ref(db, `users/${result.uid}`), { isAdmin: true });
      }
      toast.success("Admin account created");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err || "Signup failed");
    }
  };

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        {/* LEFT IMAGE */}
        <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center">
          <img
            src="/slider/2.jpeg"
            alt="Admin"
            className="img-fluid animate__animated animate__fadeInLeft"
            style={{
              maxHeight: "80%",
              borderRadius: "24px",
            }}
          />
        </div>

        {/* RIGHT FORM */}
        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <div
            className="w-100 animate__animated animate__fadeInUp"
            style={{ maxWidth: "420px" }}
          >
            <h2 className="fw-bold mb-2 text-center">Admin Registration</h2>
            <p className="text-muted text-center mb-4">
              Create your admin account
            </p>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                className="form-control mb-3 rounded-pill"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="email"
                className="form-control mb-3 rounded-pill"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="tel"
                className="form-control mb-3 rounded-pill"
                placeholder="Phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <input
                type="password"
                className="form-control mb-3 rounded-pill"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <button className="btn btn-dark w-100 rounded-pill mb-3">
                Sign Up
              </button>
            </form>

            <p className="text-center small">
              Already have an admin account?{" "}
              <Link to="/admin/login">Login here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSignup;
